// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 123 ? "icons" : chunkId) + "-" + {"68":"de1de1","123":"e89e99","225":"bf33f0","682":"947f41","956":"9d96ba"}[chunkId] + ".js";
};